export default __webpack_public_path__ + "static/media/img_company_header27.7fcb405a.png";